const IES_AUTH_URL = process.env.REACT_APP_IES_URL;
const CLIENT_ID = process.env.REACT_APP_IES_OAUTH2_CLIENT_ID;
const CENTRALIZED_LOGIN = process.env.REACT_APP_IES_CENTRALIZED_LOGIN;
let REDIRECT_URI = `${window.location.origin}/login_callback`;
const is_container_environment = process.env.REACT_APP_IS_CONTAINER_ENVIRONMENT;

export const checkAuth = () => {
    const isAuthenticated = !!localStorage.getItem("access_token");
    console.log("checkAuth:", isAuthenticated);
    return isAuthenticated;
};

export const redirectToIESLogin = () => {
    const state = Math.random().toString(36).substring(2) + Date.now().toString(36); // Creating a random value
    sessionStorage.setItem("oauth_state", state);

    if (is_container_environment == 'false') {
        REDIRECT_URI = `${window.location.origin}/catchup/login_callback`
    }

    const authUrl = `${IES_AUTH_URL}/auth/centralized-login/?clientId=${CENTRALIZED_LOGIN}&goto=${encodeURIComponent(IES_AUTH_URL)}%2Fauth%2Foauth2%2Fpearson%2Fauthorize%3Fclient_id%3D${CLIENT_ID}%26scope%3Dopenid%26response_type%3Dcode%26redirect_uri%3D${encodeURIComponent(REDIRECT_URI)}%26state%3D${state}`;

    window.location.href = authUrl;
};


export const exchangeCodeForToken = async (code) => {
   
};

export const handleAuthFlow = async (history) => {
    const params = new URLSearchParams(window.location.search);
    const codeFromIes = params.get("code");
    
    if (codeFromIes && !localStorage.getItem("access_token")) {
        try {
            await exchangeCodeForToken(codeFromIes);
            window.history.replaceState({}, document.title, "/");
        } catch (error) {
            console.error("Error including token:", error);
        }
    } else if (!checkAuth()) {
        redirectToIESLogin();
    }
};
